export const loadingActionTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_NOT_LOADING: 'SET_NOT_LOADING'
}